export const NAME = 'BrowserCoin';
export const TICKER = 'BRC';
/** Long-form unit used in balance displays, e.g. "700 BrowserCoin (BRC)". */
export const UNIT_LONG = 'BrowserCoin (BRC)';
export const TAGLINE = 'a cryptocurrency that lives in your browser';
